import { t } from "@/i18n-js/instance";
import { SubmitButton } from "@/react/components/SettingsApp/Plan/RegularPlan/SubmitButton";
import {
  capitalizeFirstLetter,
  getPreviousTier,
  isUpgrading,
  planTiers,
} from "@/react/helpers/planHelpers";
import { usePlanStatus } from "@/react/hooks/usePlanStatus";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import type { Plan } from "@circle-react/types";
import { Typography } from "@circle-react-shared/uikit/Typography";
import { FeaturesList } from "../shared/FeaturesList";

const localeRoot =
  "pricing_plans.plan_settings.plan_selection.plan_selector.plan_card";

interface PlanCardHighlightsProps {
  plan: Plan;
}

export const PlanCardHighlights = ({ plan }: PlanCardHighlightsProps) => {
  const { currentPlanTier, isCommunityOnTrial } = usePlanStatus();

  const shouldHighlightFeatures = Boolean(
    isCommunityOnTrial ||
      (currentPlanTier && isUpgrading(currentPlanTier, plan.tier)),
  );

  const featuresListTitle =
    plan.tier === planTiers.basic
      ? t(`${localeRoot}.core_features`)
      : t(`${localeRoot}.everything_plus`, {
          tier: capitalizeFirstLetter(getPreviousTier(plan.tier) ?? ""),
        });

  return (
    <div className="mt-6 px-0 sm:px-11">
      <div>
        <div className="mb-4">
          <Typography.LabelXs weight="semibold">
            {featuresListTitle}
          </Typography.LabelXs>
        </div>
        <div
          className={classNames(
            "grid auto-cols-max grid-flow-col grid-rows-8 gap-x-10 gap-y-2",
            plan.tier === planTiers.enterprise
              ? "md:grid-rows-5"
              : "md:grid-rows-4",
          )}
        >
          <FeaturesList
            plan={plan}
            shouldHighlightFeatures={shouldHighlightFeatures}
          />
        </div>
      </div>
      <div className="my-6">
        <SubmitButton plan={plan} />
      </div>
    </div>
  );
};
